import { Block } from "./block"


class Piece extends Block {

    color: string
    disabled: boolean

    constructor (rawMatrix: Array<Array<boolean | null>>, color?: string, disabled = false) {
        super(rawMatrix)
        this.color = color || `#${Math.floor(Math.random() * 0x1000000).toString(16).padStart(6, '0')}`
        this.disabled = disabled
    }

    get tips (): string {
        return "None."
    }

}


class SquarePiece extends Piece {

    get tips (): string {
        return "Put in open places."
    }

}


class CornerPiece extends Piece {

    get tips (): string {
        return "Put in corners."
    }

}


class LinePiece extends Piece {

    get tips (): string {
        return "Put in edges."
    }

}


class TrianglePiece extends Piece {

    get tips (): string {
        return "Put in edges with gaps."
    }

}


class DotPiece extends Piece {

    get tips (): string {
        return "Put in small gaps."
    }

}

export { Piece, SquarePiece, CornerPiece, LinePiece, TrianglePiece, DotPiece }
